class Converter {
    convertToSendMessage(event, message) {
        const pack = { name: event, message: message };
        return (JSON.stringify(pack));
    }
}
export const Convert = new Converter();
